import { Box, Stack, Typography, useTheme } from '@mui/material';
import React from 'react';
import { useFormikContext } from 'formik';

// Components
import ButtonWithLoading from 'src/components/common/ButtonWithLoading';
import ModalComponent from 'src/components/Modal/ModalComponent';
import FormikForm from 'src/components/common/FormikForm';
import FormItemTypeContribution from 'src/features/Contributions/Common/FormItemTypeContribution';
import FormItemStatusContribution from 'src/features/Contributions/Common/FormItemStatusContribution';
import FormItemRelationContribution from 'src/features/Contributions/Common/FormItemRelationContribution';

interface IProps {
  open: boolean;
  handleClose: () => void;
}

const FormFilterContributions: React.FC<IProps> = ({ open, handleClose }) => {
  const formik = useFormikContext<ExpectedAny>();
  const theme = useTheme();

  return (
    <ModalComponent padding={4} handleClose={handleClose} open={open}>
      <FormikForm formik={formik}>
        <Box width={540}>
          <Typography textAlign={'center'} variant="h5">
            Filter My Contribution
          </Typography>
          <Box sx={{ mt: 1 }} />
          <Typography textAlign={'center'} color={theme.palette.text.secondary} variant="body2">
            Please select the filter conditions below.
          </Typography>
          <Box sx={{ mt: 4 }} />

          <Stack direction={'column'} spacing={2}>
            <FormItemTypeContribution />
            <FormItemStatusContribution />
            <FormItemRelationContribution />
            <ButtonWithLoading sx={{ height: 53 }} size="large" variant="contained" isRounded type="submit">
              Show Result
            </ButtonWithLoading>
          </Stack>
        </Box>
      </FormikForm>
    </ModalComponent>
  );
};

export default FormFilterContributions;
